<script>
import DataLayer from '@services/data-layer/index'
import BfhsTile from '@components/bfhs/bfhs-tile'

export default {
    name: 'HomepageBfh',
    components: { BfhsTile },

    data() {
        return {
            bfh: null,
            hasLoaded: false,
        }
    },

    mounted() {
        DataLayer.bfhs.getAll({}).then(res => {
            this.bfh = res.body[0]
            this.hasLoaded = true
        })
    },
}
</script>

<template>
    <div v-if="hasLoaded && bfh">
        <BaseSection class="bfh-section">
            <BfhsTile :bfh="bfh"/>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

$section-gap-tablet: 58px;
$section-gap-desktop: 72px;

.bfh-section {
    margin-top: 0;
}

@include tablet {
    .bfh-section {
        margin-top: $section-gap-tablet;
    }
}

@include desktop {
    .bfh-section {
        margin-top: $section-gap-desktop;
    }
}
</style>
